<template>
  <div id="container" class="container"></div>
</template>

<script>
export default {
  data() {
    return {
      map: null
    }
  },
  created() {},
  mounted() {
    this.map = new AMap.Map('container', {
      zoom: 12,
      center: [123.010035, 41.086954]
    })
    let infoWindow = new AMap.InfoWindow({
      anchor: 'top-left',
      content: '鞍山市中医院'
    })

    let marker = new AMap.Marker({
      position: new AMap.LngLat(123.010035, 41.086954), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      title: 'as'
    })
    infoWindow.open(this.map, [123.010035, 41.086954])
    this.map.add(marker)
    AMap.plugin('AMap.Geolocation', function() {
      let geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: true,
        // 设置定位超时时间，默认：无穷大
        timeout: 10000,
        // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
        buttonOffset: new AMap.Pixel(10, 20),
        //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        zoomToAccuracy: true,
        //  定位按钮的排放位置,  RB表示右下
        buttonPosition: 'RB'
      })

      geolocation.getCurrentPosition(function(status, result) {
        if (status == 'complete') {
          onComplete(result)
        } else {
          onError(result)
        }
      })

      function onComplete(data) {
        // data是具体的定位信息
        window.location.href = 'https://uri.amap.com/navigation?from='+data.position.lng+','+data.position.lat+',我的位置&to=123.010035,41.086954,鞍山市中医院&midwaypoint&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0'; 
      }

      function onError(data) {
        // 定位出错
      }
    })
  },
  methods: {}
}
</script>

<style scoped>
.container {
  height: 100vh;
  width: 100vw;
}
</style>
